<template>
  <div style="height: 100%" class="bg">
    <div class="xqleft" style="padding-top:30px">
      <a-row style="text-align: center;margin-bottom: 20px;">
        <a-col :span="10" style="height: 170px; padding-top: 20px">
          <RingRing :soc="soc" />
        </a-col>
        <a-col :span="14" style="height: 170px; padding-top: 20px">

          <div style="height:100%;" class="soh">
            <!-- <v-chart class="chart" :option="options" :autoresize="true" /> -->
            {{ jzxq.soh }}%
          </div>
          <div style="padding-right:20px;text-align: center;">电池soh</div>
        </a-col>
      </a-row>
      <div class="llist">
        <ul>
          <li>
            <h2 class="shuzhi">{{ jzxq.power_reservation }}<span class="danwei">分钟</span></h2>
            <h1 class="mingcheng">剩余实时备电时长</h1>

          </li>
          <li>
            <h2 class="shuzhi">{{ jzxq.charge_discharge_total }}<span class="danwei">次</span></h2>
            <h1 class="mingcheng">累计充放电次数</h1>

          </li>
          <li style="width: 50%">
            <h2 class="shuzhi">{{ jzxq.battery_temp }}<span class="danwei">度</span></h2>
            <h1 class="mingcheng">电池温度</h1>

          </li>
          <!-- <li style="width: 33%">
            <h1 class="mingcheng">储能效率</h1>
            <h2 class="shuzhi">90<span class="danwei">%</span></h2>
          </li> -->
          <li style="width: 50%">
            <h2 class="shuzhi">{{ jzxq.battery_status }}</h2>
            <h1 class="mingcheng">电池状态</h1>

          </li>
        </ul>
      </div>
    </div>
    <div class="xqleft">
      <div style="display: flex; " class="biaoti">

        <h1 style="color: #fff; font-size: 14px; ">故障统计</h1>
      </div>
      <div>
        <GaoJing :chatdata="chatdata" />
      </div>
      <div class="llist">
        <ul>
          <li style="width: 33%">
            <h2 class="shuzhi">{{ info.warning_num_total }}<span class="danwei">次</span></h2>
            <h1 class="mingcheng">告警次数</h1>

          </li>
          <li style="width: 33%">
            <h2 class="shuzhi">{{ info.warning_process_percent }}<span class="danwei">%</span></h2>
            <h1 class="mingcheng">处理情况</h1>

          </li>
          <li style="width: 33%">
            <h2 class="shuzhi">{{ info.process_avg_time }}<span class="danwei">分钟</span></h2>
            <h1 class="mingcheng">平均处理时间</h1>

          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/api/http";
import { useStore } from "vuex";

import { defineComponent, ref, onMounted, watch } from "vue";
//import * as echarts from 'echarts';
import GaoJing from "./GaoJing.vue";
import RingRing from "./RingRing.vue";
export default defineComponent({
  components: {

    GaoJing,
    RingRing,
  },
  props: { jzxq: Object },
  setup(props) {

    const store = useStore()
    let stationid = store.getters['User/stationid']




    const options = ref({

    });


    let chatdata = ref([])
    let info = ref({
      process_avg_time: "",
      warning_num_total: "",
      warning_process_percent: "",

    })

    let soc = ref('')

    watch(props, () => {

      //options.value.series[0].data[0].value = props.jzxq.soh
      //options.value.series[2].data[0].value = props.jzxq.soh
      if (props.jzxq.soc === null) {
        soc.value = 0.2
      } else {
        soc.value = props.jzxq.soc
      }


    }, {
      deep: true
    });



    const getData = () => {
      http.get("/base_station_warning/" + stationid + "/statistics").then((res) => {
        info.value.process_avg_time = res.data.process_avg_time
        info.value.warning_num_total = res.data.warning_num_total
        info.value.warning_process_percent = res.data.warning_process_percent
        chatdata.value = res.data.warning_list


      });

    };

    onMounted(() => {
      //组件挂载时的生命周期执行的方法


      getData();
    });
    return {
      getData,
      chatdata, info, soc, options
    }


  },
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.xqleft {

  height: 44%;

  color: #fff;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
}

.bg {
  background: url("@/assets/bjk2.png");
  background-size: 100% 100%;
}

.biaoti {
  background: url("@/assets/biaoti.png") no-repeat;
  margin: 0 20px;
  padding-left: 30px;
}

.soh {
  background: url("@/assets/soh.png") no-repeat;
  width: 142px;
  height: 114px;
  text-align: center;
  padding-top: 60px;
  font-size: 18px;
  font-weight: bold;
  margin-left: 20px;
  margin-top: 20px;
}

.quxian {
  font-size: 18px;
  color: #fdff76;
}

.llist {
  padding: 20px 20px 0;
}

.llist ul li {
  float: left;
  list-style: none;
  width: 50%;
  color: #fff;
  margin-bottom: 20px;
  text-align: center;
}

.mingcheng {
  color: #ccccdc;
  font-size: 13px;
  padding: 0;
  margin: 0;
}

.shuzhi {
  color: #2489ff;
  font-size: 18px;
  padding: 0;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}

.danwei {
  color: #2489ff;
  font-size: 12px;
  padding-left: 3px;
  font-weight: bold;
}
</style>
